export const TYPE_OPTIONS = [
  {
    value: 1,
    label: '加密狗审批'
  },
  {
    value: 2,
    label: '平台应用审批'
  }
]

/* eslint-disable */
export const Type = {
  [1]: '加密狗审批',
  [2]: '平台应用审批'
}

export const rules = {
  value: [
    {
      required: true,
      message: '审批人不能为空'
    }
  ],
  level: [
    {
      required: true,
      message: '审批顺序节点不能为空'
    }
  ]
}
